import { useContext, useLayoutEffect } from 'react';
import ThemeContext from '../contexts/themeContext';

export default function useMinimizeAside() {
	const { setAsideStatus, setAsideSubStatus } = useContext(ThemeContext);
	useLayoutEffect(() => {
		setAsideStatus(false);
		setAsideSubStatus(false);
		return () => {
			setAsideStatus(true);
			setAsideSubStatus(true);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
